import { Badge } from 'antd';
import ScrollNumber from 'antd/es/badge/ScrollNumber';
export { ScrollNumber };
export default Badge;
